import { usePrpNavigation } from "./PrpNavigationContext";
import { PrpNavigationItem } from ".";
import { Avatar, Box, Typography } from "@mui/material";
import { useAuthContext } from "@/context/AuthContext";
import AddIcon from "@mui/icons-material/Add";
import { useCompanyConfigContext } from "@/context/CompanyConfigContext";

export const PrpNavigationItemHome = () => {
  const { isOpen, closeNavigation, openNavigation } = usePrpNavigation();

  return (
    <PrpNavigationItem
      item={{
        position: 0,
        action: isOpen ? closeNavigation : openNavigation,
        isSelectedCheck: () => isOpen,
        label: <HomeInner />,
      }}
      tabProps={{
        sx: {
          p: `10px !important`,
          flex: "none !important",
          opacity: "1 !important", // mui suckkxx
        },
      }}
      bottomNavigationActionProps={{
        sx: {
          position: "absolute",
          padding: 1,
          left: "0",
          right: "0",
          bottom: "100%",
          minWidth: "100%",
          justifyContent: "center",
          borderBottom: "1px solid",
          borderColor: (theme) => theme.palette.primary.contrastText,
          backgroundColor: (theme) => theme.palette.primary.light,
          "& .MuiBox-root": {
            flexDirection: "row",
          },
          "& .MuiButtonBase-root": {
            justifyContent: "center",
          },
          height: "42px",
        },
      }}
    />
  );
};

const HomeInner = () => {
  const { user } = useAuthContext();
  const { isOpen } = usePrpNavigation();
  const { settings } = useCompanyConfigContext();

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <Box
        sx={{
          pr: "0.3rem",
          ml: "-0.4rem",
          mt: "0.2rem",
          "@media (max-width:599px)": { display: "none" },
        }}
      >
        <AddIcon
          sx={{
            fontSize: "2.5rem",
            transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease-in-out",
            "@media (max-width:599px)": {
              color: (theme) => theme.palette.primary.contrastText,
            },
            "&.Mui-selected": {
              color: "white",
            },
          }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent: "stretch",
          alignItems: "stretch",
        }}
        data-cypress="user-dropdown"
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            position: "relative",
            "@media (min-width:600px)": { top: "-0.1rem" },
          }}
        >
          <Avatar
            sx={{
              width: 32,
              height: 32,
              backgroundColor: "primary.contrastText",
              color: "primary.main",
            }}
          >
            {user.firstName.charAt(0)}
            {user.lastName.charAt(0)}
          </Avatar>
          <Typography
            variant="subtitle2"
            sx={{ marginLeft: 1, textWrap: "nowrap", textTransform: "none" }}
          >
            {user.firstName} {user.lastName}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flex: 1,
            position: "relative",
            "@media (min-width:600px)": { top: "0.1rem" },
          }}
        >
          <AddIcon
            sx={{
              "@media (min-width:600px)": { display: "none" },
              fontSize: "2.5rem",
              transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease-in-out",
              "@media (max-width:600px)": {
                color: (theme) => theme.palette.primary.contrastText,
              },
              "&.Mui-selected": {
                color: "white",
              },
              position: "relative",
            }}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              flex: 1,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{ marginRight: 1, textTransform: "none" }}
            >
              {settings?.strings?.appsName || "Primary Apps"}
            </Typography>
          </Box>
          <Avatar
            src={settings?.icon}
            sx={{
              width: 32,
              height: 32,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
